import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowUp } from '@fortawesome/pro-solid-svg-icons';

export default function Placeholder() {
  return (
    <React.Fragment>
      <FontAwesomeIcon className="icon-gradient" icon={faFileArrowUp} size="4x"/>
      <h3 className="m-4"><strong>Upload Files</strong></h3>
      <div className="text-muted">Click or drag files or folders here to upload them</div>
    </React.Fragment>
  );
}
